import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router'
import { Observable, of } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class ScopeGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const scopeId = parseInt(route.paramMap.get('id') || '0')
    if (!scopeId || scopeId <= 0) {
      this.router.navigate(['/scopes'])
      return of(false)
    }
    return of(true)
  }
}
